"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewRule extends new_item_1.default {
    constructor(newRule) {
        super();
        if (!newRule.name) {
            throw Error("name required");
        }
        this.name = newRule.name;
        this.description = newRule.description;
        this.triggerLogic = newRule.triggerLogic;
        this.throttleDuration = newRule.throttleDuration;
        this.persistent = newRule.persistent;
        this.assetType = newRule.assetType;
        this.inactiveState = newRule.inactiveState;
        this.alerts = newRule.alerts;
        this.triggers = newRule.triggers;
        this.template = newRule.template;
        this._permission = newRule._permission;
        this.active = newRule.active;
        this.actions = newRule.actions;
    }
}
exports.default = NewRule;
//# sourceMappingURL=new-rule.js.map